// extracted by mini-css-extract-plugin
export default {"card":"lS","cardrow":"mS","cardcentered":"nS","details":"oS","imgwrapper":"pS","img":"qS","category":"rS","name":"sS","copy":"tS","detailsbtn":"uS","remove":"vS","price":"wS","netPrice":"xS","regularPrice":"yS","label":"zS"};
    if(module.hot) {
      // 1721922365357
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  